import { useCallback, useState } from "react"
import { useNavigate } from "react-router-dom"
import AxiosFetchData from "../pages/AxiosFetchData"
import MainPrint from "../pages/MainPrint"
import { useEffect } from "react"
import Helper from "../pages/Helper"
import ConfirmationButton from "../components/ConfirmationButton"
import { apiUrl } from "../pages/UrlParam"
import { CatchWrapperAsync } from "../utils/catchwrapper"
import { end, start } from "@popperjs/core"

export const useDailyJournalHookV2 = () => {
    const [confirmStatusOpen, setConfirmStatusOpen] = useState(false)
    const [confirmJournalOpen,setConfirmJournalOpen] = useState(false)
    const [typeError, setTypeError] = useState('')
    const [roleAccess, setRoleAcess]  = useState({})
    const [rows, setRows] = useState([])
    const [message, setmessage] = useState('')
    const [action, setAction] = useState('')
    const [data, setData] = useState('')
    const [roles, setRoles] = useState('')
    const [startDate, setStartDate] = useState(Date.now())
    const [endDate, setEndDate] = useState(Date.now())
    const [confirmEditOpen,setConfirmEditOpen] = useState(false)
    const [confirmDashboardOpen,setConfirmDashboardOpen] = useState(false)
  
    const [rowToPrint,setRowToPrint] = useState([])
    const [find,setFind] = useState('')

    const navigate = useNavigate()
    
    useEffect(()=>{
        const GetRoles =  async () =>{
            const role = await AxiosFetchData.token().refreshToken(navigate);
       
            setRoles(role)
            await BindData(role,startDate,endDate)
            setAction('ADD')
        } 
        
        GetRoles();
    },[])

    const HandleSearch = async (start, end) => {
        await BindData(roles,start,end)
        setStartDate(start)
        setEndDate(end)
    }
 
    const columns = [
            { field: 'rowNumber', headerName: 'No.', width: 80 },
            // { field: 'tanggal', headerName: 'Tanggal', width: 200, valueGetter: (value) => {
            //    return Helper.GetDateDDMMYYYY(value.row.tanggal);
            //   }  },
             { field: 'tanggal', headerName: 'Tanggal', width: 200},
            { field: 'kegiatan', headerName: 'Kegiatan', width: 250 },
            { field: 'hasil', headerName: 'Hasil', width: 200 },
            // { field: 'jumlah', headerName: 'Jumlah', width: 150 },
            // { field: 'satuan', headerName: 'Satuan', width: 150 },
            { field: 'keterangan', headerName: 'Keterangan', width: 200 },
            // { field: 'user', headerName: 'User', width: 200,sortable: false,  valueGetter: (value) => {
            //    return  resourceRows.filter((item) => item.id == value.row.resource_id)[0].nama_client;
            //   }},
            { field: 'user', headerName: 'User', width: 200 },
            { field: 'customer', headerName: 'Customer', width: 200 },
            {
                field: 'actions',
                headerName: 'Actions',
                width: 150,
                sortable: false,
                renderCell: (params) => (
                  <>
                    <button
                      onClick={() => {
                        setConfirmEditOpen(true)
                        //setAction('EDIT')
                        setData(params.row)
                      }}  
                      className="btn btn-primary mr-2 btn-sm"
                      disabled={!roleAccess.UPDATE}
                    >
                      Edit
                    </button>
                
                  <ConfirmationButton classname='btn btn-danger btn-sm' text="Do you want delete this data?" type="button" disabled={!roleAccess.DELETE} onClick={() => handleDelete(params.row.id)}>
                        Delete 
                  </ConfirmationButton>
                
                  </>
                ),
            },
        ];
    
    const BindData = useCallback(async (role,start,end) => {
         
      CatchWrapperAsync(async () =>{
        if(role != ""){
                var data = {
                    role : role.role,
                    userId : role.userID,
                    startDate : Helper.GetDateYYYYMMDD(start),
                    endDate : Helper.GetDateYYYYMMDD(end)
                }
            
                let response = await AxiosFetchData.post(`Journal`, data).refreshToken(navigate,"dailyjournal")
                setRows(response.data)
                setRoleAcess(response.roleaccess)
        }
      },setmessage, setTypeError)
        
    },[start,end])
   
    let searchJournal = useCallback(rows.map((row, index) => ({
                ...row,
                rowNumber : index + 1,
              
            })).filter((item) => {
                        let isMatch = 0;
                 
                        for(let key in item){
                            if(columns.some((data) => data.field == key))
                            {
                              
                                if(item[key] !== undefined && item[key] !== null && item[key].toString().toLowerCase().includes(find.toLowerCase().trim())) 
                                { 
                                    isMatch++;
                                }
                            }
                        }
                  
                        if(isMatch > 0){
                            isMatch = 0;
                            return true;
                        } 
 
                        return false;
    }) ,[rows,find])
     
    // searchJournal =  searchJournal.filter((item) => {
    //                     let isMatch = 0;
                 
    //                     for(let key in item){
    //                         if(columns.some((data) => data.field == key))
    //                         {
                              
    //                             if(item[key] !== undefined && item[key] !== null && item[key].toString().toLowerCase().includes(find.toLowerCase().trim())) 
    //                             { 
    //                                 isMatch++;
    //                             }
    //                         }
    //                     }
                  
    //                     if(isMatch > 0){
    //                         isMatch = 0;
    //                         return true;
    //                     } 
 
    //                     return false;
    // }) 

    const AddDaiylyJournal = async () =>{
        setConfirmStatusOpen(true)
    }

    const handleDelete = async (id) =>{
      CatchWrapperAsync(async () =>{
          let params = {
            entity : "dailyjournal",
            field :{
              isDelete : 1
            },
            where : {
              id : id
            }
          }

          await AxiosFetchData.post(`UpdateEntity`, params).refreshToken(navigate,"dailyjournal")
          await HandleSearch(startDate,endDate)
          setmessage("Daily Journal was deleted successfully")
      },setmessage)
    }

    

    const openPopupAndPrint = () => {
         
        var popup = window.open('', 'PRINT', 'height=400,width=400');
        let mainPrint = new MainPrint()
        popup.document.write(mainPrint.printDailyJournal(searchJournal));
      
        popup.print(); 
        popup.close();
    }

    return {HandleSearch,AddDaiylyJournal, confirmStatusOpen, setConfirmStatusOpen,confirmJournalOpen, 
            setConfirmJournalOpen,rows,roleAccess,setmessage,message,typeError, setTypeError,action, setAction,columns,
            data,roles,startDate,endDate,searchJournal,confirmEditOpen,setConfirmEditOpen, openPopupAndPrint,
            confirmDashboardOpen,setConfirmDashboardOpen,setRowToPrint,setFind,find
    }
}
